/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex } from '@radix-ui/themes';

import { use } from 'fierry/react';

import Route from 'solis/route';
import Galaxy from 'solis/application/galaxy';
import { useArg } from 'solis/navigation';

import Title from 'solis/react/element/title';

import * as Board from 'solis/react/board';

import BoardData from 'solis/react/board/data/board';
import ColonyData from 'solis/react/board/data/colony';
import StyledData from 'solis/react/board/data/styled';
import TransformData from 'solis/react/board/data/transform';
import LayeredData from 'solis/react/board/data/layered';

import ColonyEmphasis from 'solis/react/board/emphasis/colony';

import HexGroup from 'solis/type/hex/group';

import Markers from 'solis/claude/board/overlay/markers';

import Args from 'solis/claude/action/args';

import useAttachPlacement from 'solis/claude/action/attach/placement';

import AnchorSelection from 'solis/design-2/body/attach/selection';


const SETTINGS = { selection: new AnchorSelection(), pannable: false, zoomable: false };


const createBoardData = (board, targetColonyID) =>
{
  const boardData = new BoardData({ board });

  return new StyledData({ data: boardData, emphasis: new ColonyEmphasis(targetColonyID) });
};


const createColonyData = (colony, transform) =>
{
  const colonyData = new ColonyData({ colony });

  return new TransformData({ data: colonyData, transform });
};


const createData = (board, placement, targetColonyID) =>
{
  const styledBoard = createBoardData(board, targetColonyID);

  if (placement.transform === null)
  {
    return styledBoard;
  }

  const transformedColony = createColonyData(placement.sourceColony, placement.transform);

  return new LayeredData({ data: styledBoard, overlay: transformedColony });
};


export default () =>
{
  const route = use(Route);

  const galaxy = use(Galaxy);

  const board = galaxy.getBoard(route.getArg('id'));

  const placement = useAttachPlacement(board);

  // Only an explicitly narrowed colony reads as selected — emphasizing the derived
  // anchor would look like a selection that clicking it then actually makes.
  const anchorColony = useArg(Args.AnchorColony);

  const data = createData(board, placement, anchorColony);

  const markers = new HexGroup(placement.targets);

  if (placement.placedHexes !== null)
  {
    markers.erase(placement.placedHexes);
  }

  const overlay = <Markers hexes = {markers} color = 'gray' />;

  return (
    <Flex direction = 'column' gap = '3' p = '5'>
      <Title>{'Attach to ' + board.cass.name}</Title>

      <Board.WithData data = {data} width = {900} height = {600} zoom = {3} settings = {SETTINGS} overlay = {overlay} />
    </Flex>
  );
};
